import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeepLink } from '@shared/hooks/useDeepLink';

export const DeepLinkHandler = () => {
  const navigate = useNavigate();
  const { deepLinkData, clearDeepLink, hasDeepLink } = useDeepLink();

  useEffect(() => {
    if (hasDeepLink && deepLinkData.url) {
      console.info('>> Processing deep link for navigation:', JSON.stringify(deepLinkData));

      if (deepLinkData.pathname) {
        // Build the navigation path with query parameters
        const searchParams = deepLinkData.params;
        const queryString = createQueryParamsString(searchParams);
        const fullPath = queryString ? `${deepLinkData.pathname}?${queryString}` : deepLinkData.pathname;

        console.info('>> Navigating to:', fullPath);

        // Navigate to the deep linked path
        navigate(fullPath, { replace: true });
      }

      // Clear the deep link after processing
      clearDeepLink();
    }
  }, [hasDeepLink, deepLinkData, clearDeepLink, navigate]);

  // This component doesn't render anything
  return null;
};

const createQueryParamsString = (params: URLSearchParams | null) => {
  if (!params) return '';
  return Array.from(params.entries())
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
};
